export default window && window.Harmony;
